import Api from '@/api/api.js'
import configApi from '@/api/config/_api_config'

const configAccess = async () => {
    const response = await configApi().post('/parametres/constantes-access', {}, { constantes_config_scoped: true, timeout: 20000 })
    const token = response.data && response.data.data && response.data.data.access_token
    if (!token) throw new Error('Accès aux paramètres indisponible.')
    return { med_access_scoped: true, timeout: 20000, headers: { 'X-Constantes-Config': token } }
}

const soinsAccess = async () => {
    const access = await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })
    const token = access.data && access.data.data && access.data.data.access_token
    if (!token) throw new Error('Accès aux protocoles types indisponible.')
    return { med_access_scoped: true, timeout: 20000, headers: { 'X-Soins-Access': token } }
}

export default {
    async listeParametres() {
        const response = await Api().get('/parametres/protocoles-types', await configAccess())
        return response.data.data || []
    },
    async ajouter(data) {
        const response = await Api().post('/parametres/protocoles-types', data, await configAccess())
        return response.data
    },
    async supprimer(id) {
        const response = await Api().delete(`/parametres/protocoles-types/${id}`, await configAccess())
        return response.data
    },
    async listePourSoins() {
        const response = await Api().get('/protocoles/soins/types', await soinsAccess())
        return response.data.data || []
    },
    async ajouterPersonnel(data) {
        const response = await Api().post('/protocoles/soins/types/personnels', data, await soinsAccess())
        return response.data
    },
    async supprimerPersonnel(id) {
        const response = await Api().delete(`/protocoles/soins/types/personnels/${id}`, await soinsAccess())
        return response.data
    }
}
